export default __webpack_public_path__ + "static/ease-836619a126183215f87d8ed5b33d95ed.png";